module.exports = __webpack_public_path__ + "img/system_administration.3fa362e8.svg";